// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IOcrDuplicateDocumentWarningDto } from './IOcrDuplicateDocumentWarningDto';
import {
    instanceOfIOcrDuplicateDocumentWarningDto,
    IOcrDuplicateDocumentWarningDtoFromJSON,
    IOcrDuplicateDocumentWarningDtoFromJSONTyped,
    IOcrDuplicateDocumentWarningDtoToJSON,
} from './IOcrDuplicateDocumentWarningDto';
import type { IOcrWarningDto } from './IOcrWarningDto';
import {
    instanceOfIOcrWarningDto,
    IOcrWarningDtoFromJSON,
    IOcrWarningDtoFromJSONTyped,
    IOcrWarningDtoToJSON,
} from './IOcrWarningDto';

/**
 * @type IOcrClaimDtoWarningsInner
 * 
 * @export
 */
export type IOcrClaimDtoWarningsInner = IOcrDuplicateDocumentWarningDto | IOcrWarningDto;

export function IOcrClaimDtoWarningsInnerFromJSON(json: any): IOcrClaimDtoWarningsInner {
    return IOcrClaimDtoWarningsInnerFromJSONTyped(json, false);
}

export function IOcrClaimDtoWarningsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrClaimDtoWarningsInner {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIOcrDuplicateDocumentWarningDto(json)) {
        return IOcrDuplicateDocumentWarningDtoFromJSONTyped(json, true);
    }
    if (instanceOfIOcrWarningDto(json)) {
        return IOcrWarningDtoFromJSONTyped(json, true);
    }

    return {} as any;
}

export function IOcrClaimDtoWarningsInnerToJSON(json: any): any {
    return IOcrClaimDtoWarningsInnerToJSONTyped(json, false);
}

export function IOcrClaimDtoWarningsInnerToJSONTyped(value?: IOcrClaimDtoWarningsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIOcrDuplicateDocumentWarningDto(value)) {
        return IOcrDuplicateDocumentWarningDtoToJSON(value as IOcrDuplicateDocumentWarningDto);
    }
    if (instanceOfIOcrWarningDto(value)) {
        return IOcrWarningDtoToJSON(value as IOcrWarningDto);
    }

    return {};
}

